import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import "./Cgu.css";

const PolitiqueCookies = () => (

    <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
          POLITIQUE DE COOKIES
      </Typography>

      <Typography
        variant="subtitle2"
        align="center"
        className="cgu-date"
        gutterBottom
      >
        Dernière mise à jour : [18/09/2025]
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>
        1. Qu’est-ce qu’un cookie ?
      </Typography>
      <Typography paragraph>
      Un cookie est un petit fichier texte enregistré sur votre terminal (ordinateur, smartphone, tablette) lors de votre navigation sur un site web. Il permet notamment de reconnaître votre appareil, de sécuriser votre connexion et d’analyser l’utilisation du site.
      </Typography>

      <Typography variant="h6" gutterBottom>
        2. Quels cookies utilisons-nous ?
      </Typography>
      <Typography paragraph>
        Notre site {" "}  
        <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           cooptaleo.com
        </a>.
        utilise différents types de cookies :
      </Typography>

      <ul className="cgu-list">
        <li> <strong>Cookies strictement nécessaires </strong>  → Cookies de session : indispensables au bon fonctionnement du site (connexion utilisateur, navigation sécurisée).</li>
        <li> <strong>Cookies de mesure d’audience  </strong>  → Google Analytics : mesure de l’audience du site, pages visitées, comportement utilisateur.</li>
        <li> <strong>Cookies marketing et publicitaires  </strong>  → Facebook Pixel, Google Ads, LinkedIn Ads : suivi des performances de nos campagnes publicitaires et reciblage.</li>
      </ul>

      <Typography variant="h6" gutterBottom>
         3. Consentement
      </Typography>
      <Typography paragraph>
          Lors de votre première visite, un bandeau de consentement s’affiche.
      </Typography>
      <Typography paragraph>
        Vous pouvez :
      </Typography>
      <ul className="cgu-list">
      <li>accepter tous les cookies,</li>
      <li>refuser les cookies non essentiels,</li>
      <li>personnaliser vos choix.</li>
      </ul>
      <Typography paragraph>
      Seuls les cookies strictement nécessaires sont déposés sans consentement.
      Votre choix est conservé pendant 6 mois, après quoi il vous sera redemandé.
      </Typography>
      <Typography paragraph>
      Vous pouvez modifier votre consentement à tout moment via le gestionnaire de préférences (JS-Cookie) ou depuis les paramètres de votre navigateur.
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Durée de conservation
      </Typography>
      <ul className="cgu-list">
      <li>Les cookies sont conservés pour une durée maximale de 13 mois.</li>
      <li>Les données collectées via les cookies de mesure d’audience sont conservées pour une durée maximale de 25 mois.</li>
      </ul>

      <Typography variant="h6" gutterBottom>
      5. Gestion des cookies via votre navigateur
      </Typography>
      <Typography paragraph>
        Vous pouvez également désactiver les cookies directement depuis les paramètres de votre navigateur :{" "}
        <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
          Chrome
        </a>{" / "}
        <a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank" rel="noopener noreferrer">
          Firefox
        </a>{" / "}
        <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
          Safari
        </a>{" / "}
        <a href="https://support.microsoft.com/fr-fr/windows/g%C3%A9rer-les-cookies-dans-microsoft-edge-afficher-autoriser-bloquer-supprimer-et-utiliser-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">
          Edge
        </a>.
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        6. Plus d’informations
      </Typography>
      <Typography paragraph>
        Pour en savoir plus sur la gestion de vos données personnelles, consultez notre{" "}
        <a
            href="/confidentiality"
            style={{ textDecoration: "underline", color: "blue" }}
          >
          Politique de confidentialité (RGPD)
        </a>.
      </Typography>

    </Box>
  </Container>
  <Footer />

  </>
);

export default PolitiqueCookies;
